import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { MonitoringStatCard } from 'components/MonitoringStat/MonitoringStatCard';
import * as S from '../../styles';

export const StatsSidebar = ({
  cardStats,
  onDragStart,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDragEnd,
  systemConfiguration
}) => {
  return (
    <S.StatsCardsContainer>
      {cardStats.map((statCard, index) => (
        <S.DraggableCardContainer
          key={`card-stat-${index}`}
          id={`draggable-${index}`}
          draggable
          isAlert={statCard.isAlert}
          onDragStart={(e) => onDragStart(e, index)}
          onDragEnter={(e) => onDragEnter(e, index)}
          onDragLeave={onDragLeave}
          onDragOver={onDragOver}
          onDragEnd={onDragEnd}
        >
          <MonitoringStatCard
            {...statCard}
            backgroundColor={
              statCard.backgroundColor || systemConfiguration?.primary_color
            }
          />
          <UncontrolledTooltip placement="right" target={`draggable-${index}`}>
            <S.TooltipText>Arraste para reordenar</S.TooltipText>
          </UncontrolledTooltip>
        </S.DraggableCardContainer>
      ))}
    </S.StatsCardsContainer>
  );
};
